<div class="payment-options-title">{{ 'payment_options.title' | translate }}</div>
<div class="divider divider-light"></div>
<app-payment-option-item *ngFor="let paymentOption of paymentOptions" [paymentOption]="paymentOption"></app-payment-option-item>
